// extracted by mini-css-extract-plugin
module.exports = {"component":"edit-menu_component__15WlP"};